import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../../_services/_nav.service';
import { CampaniaDctoCiclos } from '../../../_models/campania-dcto-ciclos';
import { Campania } from '../../../_models/campania';
import { CampaniaDctoCicloService } from '../../../_services/campania-dcto-ciclo.service';
import { Funcionalidad } from '../../../_models/funcionalidad';
import { AutenticacionService } from '../../../_services/autenticacion.service';
import { ModalidadTasa } from '../../../_models/modalidad-tasa';
import { Table } from 'primeng/table';

@Component( {
  selector: 'app-campanias-dcto-ciclos',
  templateUrl: 'campanias-dcto-ciclos.component.html'
} )

export class CampaniasDctoCiclosComponent implements OnInit {

  @Input() campania: Campania;

  campaniaDctoCiclos: CampaniaDctoCiclos;
  carTabla = true;
  // Lista de campañas descuentos ciclos
  lisCampaniasDctoCiclos: CampaniaDctoCiclos [] = [];
  carInformacionInicial = false;
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];
  guardandoCampaniaDctoCiclos = false;
  submittedCampaniaDctoCiclos = false;
  menu: Funcionalidad = new Funcionalidad();
  tabSeleccionado = 'CAMC';
  @ViewChild('dt') tabla: Table;

  constructor( private autServicio: AutenticacionService,
               private camDctoCicloServicio: CampaniaDctoCicloService,
               private conServicio: ConfirmationService,
               private nav: NavService,
               private confirmationService: ConfirmationService,
               private fb: FormBuilder ) {

  }

  ngOnInit(): void {

    // Definiendo columnas datatable
    this.columnas = [
      { field: 'numeroCiclo', header: this.nav.buscarMensaje( 'CAMPANIADCTOCICLO.LBL_NUMEROCICLO' ), sort: false },
      { field: 'descuentoTasa', header: this.nav.buscarMensaje( 'CAMPANIADCTOCICLO.LBL_DESCUENTOTASA' ), sort: false },
      { field: 'acciones', header: this.nav.buscarMensaje( 'LBL_ACCIONES' ), sort: false },
    ];
    // Inicializando formulario
    this.carServicio();
    this.cargarTabla();
  }

  carServicio() {
    this.formulario = this.fb.group( {
      idCampaniaDctoCiclo: [this.campaniaDctoCiclos ? this.campaniaDctoCiclos.idCampaniaDctoCiclo : null],
      idCampania: [this.campania ? this.campania.idCampania : null, [Validators.required]],
      numeroCiclo: [this.campaniaDctoCiclos ? this.campaniaDctoCiclos.numeroCiclo : null, [Validators.required]],
      descuentoTasa: [this.campaniaDctoCiclos ? this.campaniaDctoCiclos.descuentoTasa : null, [Validators.required]],
      indicadorSuma: [this.campaniaDctoCiclos ? this.campaniaDctoCiclos.indicadorSuma : false, [Validators.required]],
      indicadorHabilitado: [this.campaniaDctoCiclos ? this.campaniaDctoCiclos.indicadorHabilitado : true, [Validators.required]],
    } );
  }

  cargarTabla() {
    this.lisCampaniasDctoCiclos = [];
    this.camDctoCicloServicio.listadoCampaniasDctoCiclosIdCampania( this.campania.idCampania ).subscribe( res => {
      this.lisCampaniasDctoCiclos = res;
      this.carTabla = false;
    } );
  }

  obtenerCampanias() {
    return this.lisCampaniasDctoCiclos.filter( x => x.indicadorHabilitado );
  }


  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      // guardar campania descuentos ciclos
      const campaniaDctoCiclos = this.formulario.value;
      this.guardando = true;
      this.crearCampaniaDctoCiclo( campaniaDctoCiclos );
    }
  }


  crearCampaniaDctoCiclo( campaniaDctoCiclos: CampaniaDctoCiclos ) {

    if ( (campaniaDctoCiclos.idCampaniaDctoCiclo !== null && campaniaDctoCiclos.idCampaniaDctoCiclo !== undefined && campaniaDctoCiclos.idCampaniaDctoCiclo !== '') ) {
      const vali = this.lisCampaniasDctoCiclos.find( x => x.numeroCiclo == campaniaDctoCiclos.numeroCiclo &&
        x.idCampaniaDctoCiclo !== this.campaniaDctoCiclos.idCampaniaDctoCiclo );
      if ( vali ) {
        this.nav.setMesage( 0, {
          severity: 'info', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.nav.buscarMensaje( 'CAMPANIADCTOCICLO.LBL_NUMEROCICLOENUSO' )
        } );
        this.guardando = false;
      } else {
        this.actualizarCampaniaDctoCiclos( campaniaDctoCiclos );
      }
    } else {
      const val = this.lisCampaniasDctoCiclos.find( x => x.numeroCiclo == campaniaDctoCiclos.numeroCiclo );
      if ( val && val.indicadorHabilitado ) {
        this.nav.setMesage( 0, {
          severity: 'info', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.nav.buscarMensaje( 'CAMPANIADCTOCICLO.LBL_NUMEROCICLOENUSO' )
        } );
        this.guardando = false;
      } else if ( val && !val.indicadorHabilitado ) {
        campaniaDctoCiclos.idCampaniaDctoCiclo = val.idCampaniaDctoCiclo;
        this.camDctoCicloServicio.actualizar( campaniaDctoCiclos ).subscribe( rta => {
          this.campaniaDctoCiclos = null;
          this.formulario.reset();
          this.cargarTabla();
          this.carServicio();
          this.submitted = false;
          this.guardando = false;
          this.nav.setMesage( 1 );
        }, error => {
          this.nav.setMesage( 3 );
          this.guardando = false;
          this.submitted = false;
        } );
      } else {
        this.agregarCampaniaDctoCiclos( campaniaDctoCiclos );
      }
    }
  }

  actualizarCampaniaDctoCiclos( campaniaDctoCiclos: CampaniaDctoCiclos ) {
    this.camDctoCicloServicio.actualizar( campaniaDctoCiclos ).subscribe( rta => {
      this.campaniaDctoCiclos = null;
      this.formulario.reset();
      this.cargarTabla();
      this.carServicio();
      this.submitted = false;
      this.guardando = false;
      this.nav.setMesage( 2 );
    }, error => {
      this.nav.setMesage( 3 );
      this.guardando = false;
      this.submitted = false;
    } );
  }

  agregarCampaniaDctoCiclos( campaniaDctoCiclos: CampaniaDctoCiclos ) {
    this.camDctoCicloServicio.crear( campaniaDctoCiclos ).subscribe( rta => {
      this.formulario.reset();
      this.cargarTabla();
      this.campaniaDctoCiclos = null;
      this.carServicio();
      this.nav.setMesage( 1 );
      this.guardando = false;
      this.submitted = false;
    }, error => {
      this.nav.setMesage( 3 );
      this.guardando = false;
      this.submitted = false;
    } );
  }

  // Carga el registro en el formulario para ser editada
  editarCampaniaDctoCiclos( campaniaDctoCiclos: CampaniaDctoCiclos ) {
    this.campaniaDctoCiclos = campaniaDctoCiclos;
    this.carServicio();
  }

  // inhabilitar el registro
  eliminarCampaniaDctoCiclos( campaniaDctoCiclos: CampaniaDctoCiclos ) {
    this.campaniaDctoCiclos = campaniaDctoCiclos;
    this.campaniaDctoCiclos.indicadorHabilitado = false;
    this.camDctoCicloServicio.actualizar( campaniaDctoCiclos ).subscribe( rta => {
      this.campaniaDctoCiclos = null;
      this.formulario.reset();
      this.cargarTabla();
      this.carServicio();
      this.submitted = false;
      this.guardando = false;
      this.nav.setMesage( 0, {
        severity: 'success', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.nav.buscarMensaje( 'CAMPANIADCTOCICLO.LBL_ELIMINARCAMPANIA' )
      } );
    }, error => {
      this.nav.setMesage( 3 );
      this.guardando = false;
      this.submitted = false;
    } );
  }

  get f() {
    return this.formulario.controls;
  }

}
